import React from 'react';
import { getMinSec } from '../../../libs/utils';

const ExerciseItem = (props) => {
  const index = props.index || 0;
  const exType = props.type;
  const styles = {
    container: {
      display: 'flex',
      width: '92%',
      height: '4rem',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: '#FFFFFF',
      marginTop: index > 0 ? 10 : 0,

      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
    },
    col1: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '20%',
      height: '100%',

      background:
        exType == 'exercise'
          ? `linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), #7367F0`
          : `linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), #4B465C`,
      color: '#FFFFFF',
      borderRadius: 5,
    },
    col2: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '78%',
      height: '100%',
      paddingLeft: '2rem',

      background:
        exType == 'exercise'
          ? `rgba(115, 103, 240, 0.08)`
          : `linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), #4B465C`,

      color: exType == 'exercise' ? '#000' : '#FFF',
      border: exType == 'exercise' ? '1px solid #7367F0' : '#4B465C',
      borderRadius: 5,
    },
  };
  return (
    <div style={{ ...styles.container }}>
      <div style={{ ...styles.col1 }}>{props.time}</div>
      <div style={{ ...styles.col2 }}>
        {exType == 'rest' ? `Rest` : props.name}
      </div>
    </div>
  );
};

const Type2box = (props) => {
  const ds = props.data;
  return (
    <div style={{ ...styles.container }}>
      <div
        style={{
          ...styles.row,
        }}
      >
        <div
          style={{
            ...styles.col,
            width: '70%',
            justifyContent: 'flex-start',
            paddingLeft: '2.5rem',
          }}
        >
          {ds && ds.title}
        </div>
        <div
          style={{
            ...styles.col,
            width: '30%',
            justifyContent: 'flex-end',
            paddingRight: '2.5rem',
          }}
        >
          {ds && ds.total && getMinSec(ds.total)}
        </div>
      </div>
      {/* [SET]------------------------------------------------ */}
      <div style={{ ...styles.setBox }}>
        <div
          style={{
            ...styles.setCol,
            background: `#242745`,
            borderRadius: 5,
          }}
        >
          <div>{`Acts`}</div>
          <div>{ds.set && ds.set['Acts']}</div>
        </div>
        <div
          style={{
            ...styles.setCol,
            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), #7367F0`,
            borderRadius: 5,
          }}
        >
          <div>{`Go`}</div>
          <div>{ds.set && ds.set['Go']}</div>
        </div>
        <div
          style={{
            ...styles.setCol,
            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #842DCE`,
            borderRadius: 5,
          }}
        >
          <div>{`Rest`}</div>
          <div>{ds.set && ds.set['Rest']}</div>
        </div>
        <div
          style={{
            ...styles.setCol,
            background: `linear-gradient(0deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), #4B465C`,
            borderRadius: 5,
          }}
        >
          <div>{`Repeat`}</div>
          <div style={{ marginTop: 4 }}>{ds.set && ds.set['Repeat']}</div>
        </div>
      </div>
      {/* ----------------------------------------------------- */}
      <div style={{ ...styles.line, marginBottom: 20 }} />
      {ds &&
        ds.exercise &&
        ds.exercise.map((item, index) => {
          return <ExerciseItem {...item} index={index} />;
        })}
      {/* ----------------------------------------------------- */}
      <div style={{ ...styles.line }} />
      <div style={{ ...styles.moreBtn }}>
        <div style={{ marginRight: 16 }}>{`View More`}</div>
        <img
          width={13}
          height={4}
          src={require('../../../assets/images/arrow_up.png')}
        />
      </div>
      {/* ----------------------------------------------------- */}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContents: 'space-between',
    // justifyContent: 'center',
    alignItems: 'center',
    background: '#FFFFFF',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: 10,
    // paddingLeft: '2.5rem',
    // paddingRight: '2.5rem',
    marginTop: 14,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
  },
  row: {
    display: 'flex',
    width: '100%',
    height: '5.4rem',
    justifyContent: 'space-between',
    padding: 0,
  },
  col: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  setBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    width: '100%',

    // font
    fontWeight: 600,
    fontSize: '1.8rem',
    lineHeight: '2.4rem',

    color: '#FFFFFF',
  },
  setCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 105,
    height: 80,
  },
  line: {
    width: '92%',
    marginTop: 20,
    border: '0.5px solid #D9D9D9',
  },
  exercise: {
    display: 'flex',
    width: '100%',
    height: '5.4rem',
    justifyContent: 'space-between',
    padding: 0,
  },
  exCol1: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20%',
  },
  exCol2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80%',
  },
  moreBtn: {
    display: 'flex',
    width: '100%',
    height: '5rem',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 0,
  },
};

export default Type2box;
